export default __webpack_public_path__ + "static/media/preflop-equity-handvshand_0006_thumb.d3503bd8.jpg";